<div class="header">
  <app-header></app-header>
</div>
<div class="container-fluid">
  <main class="row">
    

    <aside class="side-nav col-12 col-md-4 col-xl-3">
      <app-side-nav-content></app-side-nav-content>
    </aside>

    

    <section class="col-12 col-md-8 col-xl-9 p-5">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
